import { defineComponent as _defineComponent } from 'vue'
import { VCol } from 'ah-common-lib/src/common/components';
import LoadingOverlay from 'ah-common-lib/src/common/components/overlays/LoadingOverlay.vue';
import ManagedLoadingOverlay from 'ah-common-lib/src/common/components/overlays/ManagedLoadingOverlay.vue';
import kebabCase from 'lodash/kebabCase';
import mapKeys from 'lodash/mapKeys';
import { computed, useAttrs } from 'vue';

type ClassPropEl = string | { [key: string]: boolean };


export default /*#__PURE__*/_defineComponent({
  __name: 'BoxGridItem',
  props: {
    itemClass: { default: '' },
    animateTransitions: { type: [Boolean, String], default: false },
    useLoadingOverlay: { type: [Boolean, String], default: false },
    overlayType: { default: 'managed' },
    loadingOverlayProps: { default: () => {} },
    title: null
  },
  setup(__props: any) {

const props = __props as { itemClass: ClassPropEl | ClassPropEl[], animateTransitions: boolean | string, useLoadingOverlay: boolean | string, overlayType: 'managed' | 'simple', loadingOverlayProps: any, title?: string };



const attrs = useAttrs();

const overlayProps = computed(() => ({ variant: 'box', opacity: '0.85', ...props.loadingOverlayProps }));

const showLoadingOverlay = computed(() => props.useLoadingOverlay !== false);

const bColAttrs = computed(() => ({
  'align-self': 'start',
  ...mapKeys(attrs, (v, k) => kebabCase(k)),
}));

return { __sfc: true,props, attrs, overlayProps, showLoadingOverlay, bColAttrs, VCol, LoadingOverlay, ManagedLoadingOverlay }
}

})